import React from "react";
import { Paragraph } from "@tvg/design-system/web";
import { Section, StepItemContainer } from "./styled-components";

export interface InfoSectionProps {
  stepNumber: string;
  description: string;
  isFirstStep?: boolean;
  isLastStep?: boolean;
  qaLabel: string;
  isMobile: boolean;
}

const InfoSection: React.FC<InfoSectionProps> = ({
  stepNumber,
  description,
  isFirstStep,
  isLastStep,
  isMobile
}) => (
  <Section isLastStep={isLastStep}>
    <StepItemContainer
      isLastStep={isLastStep}
      isFirstStep={isFirstStep}
      isMobile={isMobile}
    >
      <Paragraph color="--fd-colors-content-strong" fontFamily="medium">
        {`${stepNumber}. `}
        {description}
      </Paragraph>
    </StepItemContainer>
  </Section>
);

export default InfoSection;
